export const TOURNAMENTS = "TOURNAMENTS";
